import {IconButton, InputBase, Paper} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import {FC, useState} from 'react'

type Props = {
  handleSearchValue?: (value: string) => void
  placeHolderText?: string
}

export const SearchInput: FC<Props> = ({handleSearchValue, placeHolderText}) => {
  const [value, setValue] = useState('')
  const handleSearch = () => {
    if (handleSearchValue) handleSearchValue(value)
  }
  return (
    <Paper
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        height: '35px',
        width: '400px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: 'none',
      }}
    >
      <InputBase
        sx={{ml: 1, flex: 1}}
        placeholder={placeHolderText ? placeHolderText : 'Tìm kiếm'}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <IconButton onClick={handleSearch} sx={{p: '10px'}} aria-label='search'>
        <SearchIcon />
      </IconButton>
    </Paper>
  )
}
